import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import "./App.css";

import Landing from "./pages/Landing";
import Demo from "./pages/Demo";
import TemplatesGallery from "./pages/TemplatesGallery";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AuthCallback from "./pages/AuthCallback";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Editor from "./pages/Editor";
import Preview from "./pages/Preview";
import PublicInvitation from "./pages/PublicInvitation";
import Checkout from "./pages/Checkout";
import Admin from "./pages/Admin";
import RsvpTracker from "./pages/RsvpTracker";
import GuestbookModerator from "./pages/GuestbookModerator";
import GuestQRCards from "./pages/GuestQRCards";
import AdminLeads from "./pages/AdminLeads";
import AdminTestimonials from "./pages/AdminTestimonials";
import AdminOrders from "./pages/AdminOrders";
import StickyCTA from "./components/StickyCTA";

function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/templates" element={<TemplatesGallery />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/editor/:id" element={<Protected><Editor /></Protected>} />
            <Route path="/preview/:id" element={<Protected><Preview /></Protected>} />
            <Route path="/checkout/:id" element={<Protected><Checkout /></Protected>} />
            <Route path="/rsvps/:id" element={<Protected><RsvpTracker /></Protected>} />
            <Route path="/guestbook/:id" element={<Protected><GuestbookModerator /></Protected>} />
            <Route path="/qr/:id" element={<Protected><GuestQRCards /></Protected>} />
            <Route path="/admin/leads" element={<Protected><AdminLeads /></Protected>} />
            <Route path="/admin/testimonials" element={<Protected><AdminTestimonials /></Protected>} />
            <Route path="/admin/orders" element={<Protected admin><AdminOrders /></Protected>} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="/i/:slug" element={<PublicInvitation />} />
          </Routes>
          <StickyCTA />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
